import Service from './service.png';
import WhyFirst from './why1.png';
import WhySecond from './why2.png';
import WhyThird from './why3.png';
import Individu from './individu.png';
import Keluarga from './keluarga.png';
import Pasangan from './pasangan.png';
import Psikologis from './psikologis.png';
import Webinar from './webinar.png';
import Workshop from './workshop.png';

const ServiceImages = {
  Service,
  WhyFirst,
  WhySecond,
  WhyThird,
  Individu,
  Keluarga,
  Pasangan,
  Psikologis,
  Webinar,
  Workshop,
};

export default ServiceImages;
